import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFullCustomerHistory } from '../../api';
import store from '../../store';
import { setNotifications } from '../slices/notifications';
import type { MockupEvent } from '../../lib/mockupEvents';

import { normalizeHistoryArgs as normalize } from '../../lib/customerHistoryKey';
import type { CustomerHistoryArgs as Args } from '../../lib/customerHistoryKey';

export type { CustomerHistoryArgs, CustomerHistoryFilter } from '../../lib/customerHistoryKey';
export { HISTORY_PAGE_SIZE, historyKey, normalizeHistoryArgs } from '../../lib/customerHistoryKey';

/** One cached list per customer + filter + range, so switching filters never mixes pages. */
export interface CustomerHistoryEntry {
    items: MockupEvent[];
    totalCount: number;
    page: number;
    perPage: number;
    status: 'idle' | 'loading' | 'resolved' | 'rejected';
    error: string | null;
}

export const getCustomerHistory = createAsyncThunk(
    'customerHistory/getCustomerFullHistory',
    async (arg: Args | string | number, { rejectWithValue }) => {
        const a = normalize(arg);
        try {
            return await getFullCustomerHistory(a.customerId, {
                page: a.page,
                limit: a.limit,
                toCart: a.filter === 'cart',
                orderExist: a.filter === 'ordered',
                minDate: a.minDate,
                maxDate: a.maxDate,
            });
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message, type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);
